<script>
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import depreciationReport from "./depreciationReport/index.vue"
import Layout from "@/router/layouts/main";

export default {
  page: {
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    PageHeader,
    depreciationReport,
    Layout
  },
  data() {
    return {
      limit: 20,
      page: 1,
      selectedFixedAsset: null,
      fixedAssets: [],
      transactions: [],
      accountingPeriods: [],
      accountFilter: {
        accounting_period_id: null,
        from: "",
        to: "",
      },
      search: "",

    };
  },
  computed: {

  },
  methods: {
   
  },
  created() {
  },
};
</script>

<template>
  <Layout >

    <PageHeader :dir="$i18n.locale == 'ar' ? 'rtl' : ''" :title="$t('fixed_assets.fixed_report')" />
  
      <b-tabs
        fill
        content-class="p-4"
        class="pt-2"
        nav-wrapper-class="nav-item"
        nav-class=" nav-tabs-custom"
      >
        <!-- marketing channels -->
        <b-tab   :title="$t('fixed_assets.depreciation_report')" active>
        <depreciation-report/>
        </b-tab>
    
       
    
        

        <!-- marketing areas -->
      </b-tabs>
 
  </Layout>
</template>
<style scoped>
.print {
  display: none;
}

@media print {
  .no-print {
    display: none;
  }

  .print {
    display: block;
  }
}

/*
.table,
td {
  border: 1px solid black;
}
*/
</style>
